<div class="settings-container">
  <p>{{ 'CUSTOM_FIELDS.LABELS.PIPELINES_WARNING' | translate }}</p>
  @if (existingPipelinesLoading()) {
    <glxy-loading-spinner [inline]="true"></glxy-loading-spinner>
  } @else {
    @for (rowGroup of pipelinesForm.controls; track $index; let i = $index; let first = $first) {
      <div class="row" [formGroup]="rowGroup">
        <div class="col-sm-4">
          <glxy-form-field [showLabel]="true" bottomSpacing="small" [hideRequiredLabel]="true">
            @if (first) {
              <glxy-label>{{ 'CUSTOM_FIELDS.LABELS.PIPELINE_NAME' | translate }}</glxy-label>
            }
            <input type="text" matInput formControlName="name" />
          </glxy-form-field>
        </div>
        <div class="col-sm-4">
          <glxy-form-field [showLabel]="true" bottomSpacing="small" [hideRequiredLabel]="true">
            @if (first) {
              <glxy-label>{{ 'CUSTOM_FIELDS.LABELS.SELECT_FIELD_FOR_PIPELINE' | translate }}</glxy-label>
            }

            <mat-select formControlName="fieldId" (opened)="onSelectOpened(rowGroup)">
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="searchControl"
                  [placeholderLabel]="'CUSTOM_FIELDS.LABELS.SEARCH_FIELD' | translate"
                  [noEntriesFoundLabel]="'CUSTOM_FIELDS.LABELS.NO_FIELDS_FOUND' | translate"
                ></ngx-mat-select-search>
              </mat-option>
              @if (fieldsLoading()) {
                <glxy-loading-spinner [inline]="true"></glxy-loading-spinner>
              } @else {
                @for (field of fieldSchemaOptions().values(); track field.schema.fieldId) {
                  <mat-option [value]="field.schema.fieldId">{{ field.schema.fieldName }}</mat-option>
                }
                @if (hasMore()) {
                  <glxy-infinite-scroll-trigger (isVisible)="loadMore()"></glxy-infinite-scroll-trigger>
                }
              }
            </mat-select>
          </glxy-form-field>
        </div>
        <div class="delete-button" [class.delete-button-first]="first" [class.delete-button-rest]="!first">
          <button
            mat-icon-button
            type="button"
            (click)="deletePipeline(i)"
            [attr.aria-label]="'CUSTOM_FIELDS.LABELS.DELETE_PIPELINE' | translate"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      @if (isExistingPipeline(rowGroup)) {
        <div class="stages-preview-row">
          <p class="stages-label">{{ 'CUSTOM_FIELDS.LABELS.CURRENT_STAGES' | translate }}</p>
          <div class="stages-preview-columns">
            @for (name of getStageNames(rowGroup); track name) {
              <span class="stage-option">{{ name }}</span>
            }
          </div>
        </div>
      }
      @if (showNewStages(rowGroup)) {
        <div class="stages-preview-row">
          <p class="stages-label">{{ 'CUSTOM_FIELDS.LABELS.NEW_STAGES' | translate }}</p>
          <div class="stages-preview-columns">
            @for (name of getFieldOptions(rowGroup); track name) {
              <span class="stage-option">{{ name }}</span>
            }
          </div>
        </div>
      }
    }
  }
  <div class="add-button">
    <button mat-stroked-button type="button" (click)="addPipeline()">
      <mat-icon>add</mat-icon>
      {{ 'CUSTOM_FIELDS.LABELS.ADD_PIPELINE' | translate }}
    </button>
  </div>
</div>

<button mat-flat-button color="primary" (click)="onSaveClick()" type="button" [disabled]="!canSave || saving()">
  {{ 'CUSTOM_FIELDS.LABELS.SAVE' | translate }}
</button>
